export class SoakStyleDropDownDto{
    soakstyleId:number;
    soakstyle:string;

  /**
   * 
   * @param soakstyleId 
   * @param soakstyle 
   */
    constructor(soakstyleId:number, soakstyle:string){
         this.soakstyleId = soakstyleId;
         this.soakstyle = soakstyle;
    }
}